/** 应用头部配置 */
export default {
  extra: { component: 'c-app-header-extra' },
  // 下载列表
  downloads: {
    dialog: { noFooter: true },
    query: { api: 'base.searchExportTask', isHost: true },
    list: {
      search: {
        items: [{ label: '日期', type: 'date-range-picker', prop: 'startTime', toProp: 'endTime', span: 12 }]
      },
      table: {
        export: { fileName: '下载列表' },
        operation: {
          width: 80,
          items: [
            {
              action: 'download',
              link: '${data.row.remoteFileId}',
              fileSource: 'downloads',
              fileName: '${data.row.exportName}',
              fileExtName: '.xlsx',
              visibleOn: 'this.data.row.status === 2'
            }
          ]
        },
        columns: [
          { label: '文件类型', prop: 'exportType', width: 120 },
          { label: '文件名', prop: 'exportName', minWidth: 120 },
          { label: '状态', prop: 'statusName', width: 100 },
          { label: '备注', prop: 'remark', minWidth: 150 },
          { label: '创建时间', prop: 'createdDate', width: 150 }
        ]
      }
    }
  },

  notify: {
    popover: {
      width: '450px'
    }
  },

  search: {}
}
